import { render } from "./App.vue?vue&type=template&id=10d89e32"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=10d89e32&lang=scss"

import exportComponent from "D:\\前端交接\\project\\project\\赛事\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__